import { render, staticRenderFns } from "./RadioGender.vue?vue&type=template&id=a423ec82"
import script from "./RadioGender.vue?vue&type=script&lang=js"
export * from "./RadioGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports